import React from "react";

interface SkeletonItemProps {
  count?: number;
}

export const SkeletonItem: React.FC<SkeletonItemProps> = ({ count = 4 }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 483);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <div 
      key={index} 
      className="goods-item skeleton-item"
      style={isMobile ? { height: 'auto', paddingTop: 30, paddingBottom: 20 } : {}}
    >
      {/* Skeleton для иконки скидки */}
      <div className="skeleton-discount-icon" style={{
        position: "absolute",
        marginTop: 130,
        width: 24,
        height: 24,
        borderRadius: "50%",
        backgroundColor: "#f0f0f0",
        animation: "pulse 1.5s ease-in-out infinite"
      }} />

      {/* Desktop версия */}
      {!isMobile && (
        <>
          {/* Skeleton для изображения товара */}
          <div className="goods-item-img">
            <div className="skeleton-image" style={{
              width: "100%",
              height: 200,
              backgroundColor: "#f0f0f0",
              borderRadius: 8,
              animation: "pulse 1.5s ease-in-out infinite"
            }} />
          </div>

          {/* Skeleton для стикеров */}
          <div className="goods-item-sticker">
            <div style={{
              display: "flex",
              gap: 8,
              marginBottom: 12
            }}>
              <div className="skeleton-sticker" style={{
                width: 60,
                height: 24,
                backgroundColor: "#f0f0f0",
                borderRadius: 12,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
              <div className="skeleton-sticker" style={{
                width: 50,
                height: 24,
                backgroundColor: "#f0f0f0",
                borderRadius: 12,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
            </div>
          </div>

          {/* Skeleton для цены */}
          <div className="skeleton-price" style={{
            marginBottom: 12
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 8
            }}>
              <div style={{
                width: 80,
                height: 24,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
              <div style={{
                width: 60,
                height: 18,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
            </div>
          </div>

          {/* Skeleton для названия товара */}
          <div className="goods-content-text">
            <div className="skeleton-product-name" style={{
              marginBottom: 8
            }}>
              <div style={{
                width: "90%",
                height: 16,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
              <div style={{
                width: "70%",
                height: 16,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                marginTop: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
            </div>
            
            {/* Skeleton для статуса доступности */}
            <div className="skeleton-availability" style={{
              marginBottom: 12
            }}>
              <div style={{
                width: 100,
                height: 16,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
            </div>
          </div>

          {/* Skeleton для кнопки корзины */}
          <div className="skeleton-basket-button" style={{
            marginTop: 12
          }}>
            <div style={{
              width: "100%",
              height: 40,
              backgroundColor: "#f0f0f0",
              borderRadius: 8,
              animation: "pulse 1.5s ease-in-out infinite"
            }} />
          </div>
        </>
      )}

      {/* Mobile версия */}
      <div
        className="goods-item-img"
        style={
          isMobile
            ? { paddingTop: 20, height: 'auto' }
            : { display: "none" }
        }
      >
        {/* Skeleton для изображения товара (мобильная версия) */}
        <div className="skeleton-image-mobile" style={{
          width: "100%",
          height: 150,
          backgroundColor: "#f0f0f0",
          borderRadius: 8,
          animation: "pulse 1.5s ease-in-out infinite"
        }} />

        <div
          className="goods-content-text"
          style={
            isMobile ? { marginTop: -20 } : { display: "none" }
          }
        >
          {/* Skeleton для названия товара (мобильная версия) */}
          <div className="skeleton-product-name" style={{
            marginBottom: 8
          }}>
            <div style={{
              width: "90%",
              height: 16,
              backgroundColor: "#f0f0f0",
              borderRadius: 4,
              animation: "pulse 1.5s ease-in-out infinite"
            }} />
            <div style={{
              width: "70%",
              height: 16,
              backgroundColor: "#f0f0f0",
              borderRadius: 4,
              marginTop: 4,
              animation: "pulse 1.5s ease-in-out infinite"
            }} />
          </div>
          
          {/* Skeleton для статуса доступности (мобильная версия) */}
          <div className="skeleton-availability" style={{
            marginBottom: 12
          }}>
            <div style={{
              width: 100,
              height: 16,
              backgroundColor: "#f0f0f0",
              borderRadius: 4,
              animation: "pulse 1.5s ease-in-out infinite"
            }} />
          </div>

          {/* Skeleton для цены (мобильная версия) */}
          <div className="skeleton-price-mobile" style={{
            marginBottom: 12
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 8
            }}>
              <div style={{
                width: 80,
                height: 24,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
              <div style={{
                width: 60,
                height: 18,
                backgroundColor: "#f0f0f0",
                borderRadius: 4,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
            </div>
            
            {/* Skeleton для стикеров (мобильная версия) */}
            <div style={{
              display: "flex",
              gap: 8,
              marginBottom: 12
            }}>
              <div className="skeleton-sticker" style={{
                width: 60,
                height: 24,
                backgroundColor: "#f0f0f0",
                borderRadius: 12,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
              <div className="skeleton-sticker" style={{
                width: 50,
                height: 24,
                backgroundColor: "#f0f0f0",
                borderRadius: 12,
                animation: "pulse 1.5s ease-in-out infinite"
              }} />
            </div>
          </div>

          {/* Skeleton для кнопки корзины (мобильная версия) */}
          <div className="skeleton-basket-button" style={{
            marginTop: 12
          }}>
            <div style={{
              width: "100%",
              height: 40,
              backgroundColor: "#f0f0f0",
              borderRadius: 8,
              animation: "pulse 1.5s ease-in-out infinite"
            }} />
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
          
          .skeleton-item {
            position: relative;
            background: white;
            border-radius: 8px;
            padding: 16px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s ease;
            margin-bottom: 20px;
          }
          
          .skeleton-item:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          
          .skeleton-image,
          .skeleton-image-mobile {
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: pulse 1.5s ease-in-out infinite, shimmer 2s infinite;
          }
          
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
          
          @media (max-width: 483px) {
            .skeleton-item {
              padding: 12px;
            }
          }
        `}
      </style>
      {skeletonItems}
    </>
  );
};

// Компонент для отображения сетки skeleton карточек
export const SkeletonGrid: React.FC<{ count?: number; columns?: number }> = ({ 
  count = 6, 
  columns = 3 
}) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 483);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const mobileColumns = isMobile ? 1 : columns;

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: `repeat(${mobileColumns}, 1fr)`,
      gap: "20px",
      padding: "20px"
    }}>
      <SkeletonItem count={count} />
    </div>
  );
};

// Компонент для отображения списка skeleton карточек
export const SkeletonList: React.FC<{ count?: number }> = ({ count = 6 }) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      padding: "20px"
    }}>
      <SkeletonItem count={count} />
    </div>
  );
};

export default SkeletonItem; 